import { pointAPI } from '@/services-ts/axios'
import type { IPaging } from '@/types/Request'
import type { IRevokeOrder, IUpdateOrder } from '@/types/Request/PointAPI'
import type { IOrderStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useOrderStore = defineStore('order', {
  state: (): IOrderStore => ({
    orderList: {
      data: [],
      total: 0,
    },
  }),

  actions: {
    async GetOrderList(payload: IPaging) {
      const { status, data, total } = await pointAPI.OrderServices.GetOrderList(payload)
      this.orderList = status ? { data, total: total || 0 } : { data: [], total: 0 }
    },

    async RevokeOrder(payload: IRevokeOrder) {
      const { status } = await pointAPI.OrderServices.RevokeOrder(payload)
      if (status) {
        const item = this.orderList.data.find(item => item.id === payload.Id)

        if (item) {
          item.orderStatusTypeId = payload.OrderStatusTypeId
          item.revokeDetail = payload.RevokeDetail
        }

        void Alert({ message: Format('admin_order_revoked'), type: 'success' })
      }
    },

    async UpdateOrder(payload: IUpdateOrder) {
      const { status } = await pointAPI.OrderServices.UpdateOrder(payload)
      if (status) {
        const item = this.orderList.data.find(item => item.id === payload.Id)

        if (item) {
          item.orderStatusTypeId = payload.OrderStatusTypeId
          item.note = payload.Note
        }

        void Alert({
          message: Format('admin_components_reward_custom_orders_statuschanged'),
          type: 'success',
        })
      }
    },
  },
})
